import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { KeeniconComponent } from '../../partials';

@Component({
  selector: 'ui-info-card',
  imports: [KeeniconComponent],
  templateUrl: './info-card.component.html',
  styleUrl: './info-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InfoCardComponent {
  icon = input<string>('');
  text = input<string>('');
  iconClass = input<string>('fs-3 text-success me-2');
  count = input<number>(0);
}
